

(function () {
  'use strict';

  if (!customElements.get('cerus-header')) {
    customElements.define('cerus-header', class extends HTMLElement {
      connectedCallback() { initHeader(this); }
    });
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function initHeader(header) {
    var mode = header.dataset.stickyMode || 'on-scroll-up';
    var lastY = window.scrollY;
    var hidden = false;
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        var goingDown = y > lastY;
        var pastThreshold = y > 80;

        header.classList.toggle('is-scrolled', y > 8);

        if (mode === 'on-scroll-up') {
          if (goingDown && pastThreshold && !hidden) {
            header.classList.add('is-hidden');
            hidden = true;
          } else if (!goingDown && hidden) {
            header.classList.remove('is-hidden');
            hidden = false;
          }
        }

        lastY = y;
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    initDrawer(header);
    initUtility(header);
    initStickyOffsets(header);
  }


  function initStickyOffsets(header) {
    var headerSection = header.closest('.cerus-header-section') || header.parentNode;

    function measure() {
      var hh = header.offsetHeight;
      var announceSection = document.querySelector('.shopify-section:has([data-cerus-announce])');
      var announceEl = announceSection && announceSection.querySelector('[data-cerus-announce]');
      var ah = announceEl ? announceEl.offsetHeight : 0;
      var root = document.documentElement.style;

      root.setProperty('--cerus-header-h', hh + 'px');
      root.setProperty('--cerus-announce-h', ah + 'px');
      root.setProperty('--cerus-header-group-h', (hh + ah) + 'px');

      if (!announceSection) {
        root.setProperty('--cerus-header-top', '0px');
        return;
      }

      var pos = announceSection.compareDocumentPosition(headerSection);
      var announceFirst = (pos & Node.DOCUMENT_POSITION_FOLLOWING) !== 0;
      if (announceFirst) {

        root.setProperty('--cerus-announce-top', '0px');
        root.setProperty('--cerus-header-top', ah + 'px');
      } else {

        root.setProperty('--cerus-header-top', '0px');
        root.setProperty('--cerus-announce-top', hh + 'px');
      }
    }
    measure();
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      ro.observe(header);
      var ann = document.querySelector('[data-cerus-announce]');
      if (ann) ro.observe(ann);
    }

    document.addEventListener('shopify:section:load', measure);
    document.addEventListener('shopify:section:unload', measure);
  }

  function initDrawer(header) {
    var drawer = document.querySelector('[data-cerus-drawer]');
    if (!drawer) return;

    var toggleBtn = header.querySelector('[data-cerus-drawer-toggle]');
    var closeBtns = $$('[data-cerus-drawer-close]', drawer);

    function open() {
      drawer.hidden = false;

      drawer.offsetHeight;
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 320);
    }

    if (toggleBtn) toggleBtn.addEventListener('click', open);
    closeBtns.forEach(function (btn) { btn.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    $$('[data-cerus-drawer-expand]', drawer).forEach(function (trigger) {
      var item = trigger.closest('.cerus-drawer__item');
      var panel = item && item.querySelector('.cerus-drawer__item-panel');
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var expanded = item.classList.toggle('is-expanded');
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        panel.hidden = !expanded;
      });
    });
  }



  function openSmartCart() {
    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
      window.Rebuy.SmartCart.show();
      return true;
    }
    if (window.rebuy_cart && typeof window.rebuy_cart.show === 'function') {
      window.rebuy_cart.show();
      return true;
    }

    try {
      document.dispatchEvent(new CustomEvent('rebuy:smartcart:open'));
    } catch (e) {  }
    return false;
  }

  function openSmartCartWithRetry() {
    if (openSmartCart()) {
      return;
    }
    var tries = 0;
    (function retry() {
      if (openSmartCart() || tries >= 20) {
        return;
      }
      tries++;
      setTimeout(retry, 150);
    })();
  }

  function initUtility(header) {
    var cartToggle = header.querySelector('[data-cerus-cart-toggle]');
    if (cartToggle) {
      cartToggle.addEventListener('click', function (e) {
        e.preventDefault();
        openSmartCartWithRetry();
      });
    }

    try {
      if (sessionStorage.getItem('cerus_open_cart')) {
        sessionStorage.removeItem('cerus_open_cart');
        openSmartCartWithRetry();
      }
    } catch (e) {}

    var searchToggle = header.querySelector('[data-cerus-search-toggle]');
    if (searchToggle) {
      searchToggle.addEventListener('click', function (e) {
        e.preventDefault();
        openSearchOverlay();
      });
    }
  }

  function openSearchOverlay() {
    var overlay = document.querySelector('[data-cerus-search-overlay]');
    if (!overlay) { window.location.href = '/search'; return; }
    overlay.hidden = false;
    void overlay.offsetHeight;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var input = overlay.querySelector('[data-cerus-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearchOverlay() {
    var overlay = document.querySelector('[data-cerus-search-overlay]');
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 220);
  }

  function initSearchOverlay() {
    var overlay = document.querySelector('[data-cerus-search-overlay]');
    if (!overlay) return;

    var input = overlay.querySelector('[data-cerus-search-input]');
    var results = overlay.querySelector('[data-cerus-search-results]');
    var closeEls = overlay.querySelectorAll('[data-cerus-search-close]');

    closeEls.forEach(function (el) {
      el.addEventListener('click', closeSearchOverlay);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearchOverlay();
    });

    if (!input || !results) return;

    var debounceTimer = null;
    var lastQuery = '';

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (debounceTimer) clearTimeout(debounceTimer);
      if (q === lastQuery) return;
      lastQuery = q;
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounceTimer = setTimeout(function () { fetchPredictive(q, results); }, 180);
    });
  }

  function fetchPredictive(query, container) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          container.innerHTML = '<div class="cerus-search-overlay__empty">No results for ' + escapeHtml(query) + '</div>';
          return;
        }
        container.innerHTML = products.map(function (p) {
          var img = p.image ? '<img class="cerus-search-overlay__result-image" src="' + p.image + '" alt="" loading="lazy">' : '<span class="cerus-search-overlay__result-image"></span>';
          var price = p.price ? '<span class="cerus-search-overlay__result-price">' + p.price + '</span>' : '';
          return '<a class="cerus-search-overlay__result" href="' + p.url + '">' +
                   img +
                   '<span class="cerus-search-overlay__result-info">' +
                     '<span class="cerus-search-overlay__result-title">' + escapeHtml(p.title || '') + '</span>' +
                     price +
                   '</span>' +
                 '</a>';
        }).join('');
      })
      .catch(function () {  });
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchOverlay);
  } else {
    initSearchOverlay();
  }

  // ---- Cart count live update ----
  document.addEventListener('cart:updated', function (e) {
    var count = (e.detail && typeof e.detail.itemCount === 'number') ? e.detail.itemCount : null;
    if (count === null && e.detail && e.detail.cart && typeof e.detail.cart.item_count === 'number') {
      count = e.detail.cart.item_count;
    }
    if (count === null) return;
    var el = document.querySelector('[data-cerus-cart-count]');
    if (!el) return;
    el.textContent = String(count);
    el.hidden = count <= 0;
  });

  // (Announcement bar runtime moved to cerus-announce.js so the section is self-sufficient.)
})();
